import { Component, OnInit } from '@angular/core';
import { NetworkService } from "./service/network.service";
import { TranslationService } from './service/translation.service';
import { RouterOutlet } from '@angular/router';
import { LoadingErrorComponent } from "./components/loading-error/loading-error.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NetworkService, TranslationService],
  imports: [RouterOutlet, TranslateModule, LoadingErrorComponent],
  standalone: true
})
export class AppComponent implements OnInit {

  public ready = false

  constructor(
    private readonly networkService: NetworkService,
    private readonly translateService: TranslationService
  ) {}

  /**
    * Await environment loading and user authentification before
    * 
    * launch application by boolean 'ready'
    */
  public ngOnInit(): void {
    this.networkService.loadEnvironment().then(async () => {
      this.translateService.initializeTranslation();
      this.ready = true;
    });
  }

}

